import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, Field, SubmitBtn, ErrorNote } from "./AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      // SECURITY: the API never returns the reset token/URL. The link is delivered
      // only by e-mail to the real account owner. We only show a neutral confirmation.
      setMessage(
        data?.message ||
          "Si un compte existe pour cet e-mail, un lien de réinitialisation vient d'être envoyé."
      );
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Saisissez votre e-mail : nous vous enverrons un lien de réinitialisation."
      footer={
        <Link to="/login" data-testid="link-back-login" className="font-semibold text-[#3E7256] hover:underline">
          Retour à la connexion
        </Link>
      }
    >
      {!done ? (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <ErrorNote>{error}</ErrorNote>
          <Field
            label="E-mail"
            type="email"
            data-testid="forgot-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vous@organisation.com"
            required
          />
          <SubmitBtn loading={loading} data-testid="forgot-submit">
            Envoyer le lien
          </SubmitBtn>
        </form>
      ) : (
        <div className="space-y-4" data-testid="forgot-result">
          <div className="flex items-start gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
            <MailCheck size={18} className="mt-0.5 shrink-0 text-emerald-600" />
            <span data-testid="forgot-confirmation">{message}</span>
          </div>
          <p className="text-xs text-slate-500">
            Vérifiez votre boîte de réception (et vos indésirables). Le lien est valable 1 heure.
          </p>
        </div>
      )}
    </AuthShell>
  );
}
